/**
 * 매장관리자 홈 Container
 * --
 */
import React from 'react';
// import MainHomePresenter from './MainHomePresenter';
import SalesDetailDashboardContainer from 'routes/admin.routes/admin.sale/SaleDashboard';
import { useUserStack } from 'store';

const SalesDetailDashboard = () => {
  /* ===== ROUTE ===== */
  const userInfo = useUserStack();
  /* ===== PROPS ===== */
  /* ===== STATE ===== */
  /* ===== VARIABLE ===== */
  /* ===== FUNCTION ===== */
  /* ===== HOOKS ===== */
  /* ===== RENDER ===== */
  return (
    <>
      {userInfo && (
        <SalesDetailDashboardContainer
          permission={userInfo.type}
          defaultShopId={userInfo.shop_information_id}
          shopType={'STORE'}
        />
      )}
    </>
  );
};

export default SalesDetailDashboard;
